const KEY = 'mcp_new_user_signup'

/** Set the new-user-signup flag unless the user already completed qualification */
export function flagNewUserSignupIfNeeded() {
  if (localStorage.getItem(KEY) !== 'false') {
    localStorage.setItem(KEY, 'true')
  }
}

/** Mark qualification as complete so the flag is never re-set */
export function markQualificationComplete() {
  localStorage.setItem(KEY, 'false')
}
